import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { useDeedsUI } from "../DeedsUIContext";

const SearchField = ({ options, style }) => {
  const { chipValues, setChipValues } = useDeedsUI();

  return (
  <Autocomplete
    style={style}
    freeSolo
    size="small"
    multiple
    options={options}
    getOptionLabel={(option) => option.title}
    groupBy={(option) => option.type}
    value={chipValues}
    onChange={(event, newValue) => {
      setChipValues(newValue);
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="standard"
        // placeholder={chipValues.length > 0 ? ` ${totalCount} found` : ""}
        InputProps={{
          ...params.InputProps,
          disableUnderline: true,
          sx: {
            boxShadow: 'none',
            border: 'none',
          }
        }}
      />
    )}    
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          variant={option.type === "Bucket" ? "default" : "outlined"}
          // color={option.type === "Bucket" ? "secondary" : "primary"}
          label={option.title}
          size="small"
          {...getTagProps({ index })}
        />
      ))
    }
    renderOption={(props, option, { inputValue }) => {
      // Search bolding
      const matches = match(option.title, inputValue, { insideWords: true });
      const parts = parse(option.title, matches);

      return (
        <li {...props}>
          <div>
            {parts.map((part, index) => (
              <span
                key={index}
                style={{
                  fontWeight: part.highlight ? 700 : 400,
                }}
              >
                {part.text}
              </span>
            ))}
          </div>
        </li>
      );
    }}
  />
  );
};

export default SearchField;
